import { Component, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { DocumentModel } from "../../../../../core/ek-e-commerce/ek-models/document.model";
import { DocumentService } from "../../../../../core/services/document.service";
import { EkSnackBarService } from "../../../../../core/services/ek-snackBar.service";

@Component({
  selector: "kt-empty-bank-docs",
  templateUrl: "./empty-bank-docs.component.html",
  styleUrls: ["./empty-bank-docs.component.scss"],
})
export class EmptyBankDocsComponent implements OnInit {
  currentRole = "";

  bankDocuments$ = new BehaviorSubject<DocumentModel[]>([]);

  // The list of empty bank templates (BANK_EMPTY) to display in the grid.
  // Each gender matches the files-card grid used in folder step 4.

  bankDocs: {
    title: string;
    titleFr: string;
    titleAr?: string;
  }[] = [
    {
      title: "BANK_DEBIT_AUTHORIZATION",
      titleFr: "Autorisation de prélèvement bancaire",
      titleAr: "إذن بالخصم المباشر من حساب بنكي",
    },
    {
      title: "DIRECT_DEBIT_AUTHORIZATION",
      titleFr: "Autorisation de prélèvement",
      titleAr: "شهادة الخصم المباشر",
    },
    {
      title: "AUTHORIZATION_TO_CONSULT_THE_CREDIT_BUREAU",
      titleFr: "Autorisation de consultation de la centrale des risques",
      titleAr: "إذن باستشارة مكتب الائتمان",
    },
    {
      title: "REQUEST_FOR_FINANCING",
      titleFr: "Demande de financement",
      titleAr: "طلب تمويل",
    },
    {
      title: "ACCOUNT_OPENING_REQUEST",
      titleFr: "Demande ouverture de compte",
      titleAr: "طلب فتح حساب",
    },
    {
      title: "COMMITMENT_TO_MAINTAIN_SUFFICIENT_BALANCE_UNDER_CCP_ACCOUNT",
      titleFr: "Engagement de maintien solde suffisant sous compte CCP",
      titleAr: "الالتزام بالحفاظ على رصيد كافٍ تحت حساب CCP",
    },
    {
      title: "SIGNATURE_SHEET",
      titleFr: "Fiche de signature",
      titleAr: "استمارة التوقيع",
    },
    {
      title: "FACTA",
      titleFr: "FACTA",
      titleAr: "استمارة FATCA",
    },
    {
      title: "ANNEX_PROTECTION_DATA",
      titleFr: "Annexe – protection des données",
      titleAr: "الملحق – حماية البيانات",
    },
  ];

  constructor(
    private documentService: DocumentService,
    private EkSnackBar: EkSnackBarService,
  ) {
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "null");
    this.currentRole = currentUser?.roles || "";
  }

  ngOnInit(): void {
    this.loadTemplates();
  }

  /**
   * Loads the standalone empty bank templates (BANK_EMPTY, folder = null).
   */
  loadTemplates() {
    this.documentService.getEmptyBankTemplates().subscribe({
      next: (res: any) => {
        this.bankDocuments$.next(Array.isArray(res?.body) ? res.body : []);
      },
      error: () => {
        this.bankDocuments$.next([]);
      },
    });
  }

  onUploadChange() {
    this.loadTemplates();
  }

  /**
   * Resolves the standalone document id for the given template gender from the
   * currently loaded bankDocuments$. Pipes are not allowed inside (click)
   * action expressions, so this helper replaces the inline pipe usage.
   */
  getIdForGender(gender: string): number {
    const docs: DocumentModel[] = this.bankDocuments$.value;
    if (!docs) {
      return 0;
    }
    const match = docs.find((doc) => doc.documentsGender === gender);
    return match?.id ? match?.id : 0;
  }

  /**
   * Hard-deletes a standalone empty template via the existing delete endpoint.
   */
  deleteDocument(id: number) {
    if (!id) {
      return;
    }
    this.documentService.deleteDocument(id).subscribe({
      next: () => {
        this.EkSnackBar.openSnackBar(
          "Document supprimé avec succès.",
          "",
          "success-snackbar",
        );
        this.loadTemplates();
      },
      error: () => {
        this.EkSnackBar.openSnackBar(
          "Échec de la suppression du document, veuillez réessayer.",
          "",
          "error-snackbar",
        );
      },
    });
  }
}
